import React from "react";
import PropTypes from "prop-types";
import { ChevronDown } from "react-ikonate";

import styles from "./MonthLink.module.css";

/**Displays a month and year for archived agenda items. When clicked the page will change to a list of all archived agenda items from that month and year. */
export function MonthLink({ month = "", year = "", onClick, content = "" }) {
  return (
    <div
      className={styles.monthLinkContainer}
      onClick={() => onClick(month, year)}
    >
      {(month && year && `${month} ${year}`) || ""}
      {content || ""}
      <ChevronDown className={styles.chevron} />
    </div>
  );
}

MonthLink.propTypes = {
  /** Displays the month */
  month: PropTypes.string,
  /**  Displays the year */
  year: PropTypes.string,
  /** Function to change page to list of archived agenda items from that month and year */
  onClick: PropTypes.func,
};
